// extracted by mini-css-extract-plugin
export default {"templateWithoutMenuContent":"NavbarWithPlacesSelector_templateWithoutMenuContent__C1tR4"};